$.extend(true, BT, {
	openRpInterval: function(minuteFrom, minuteTo, openTime, closeTime) {
    const selector = this.selectors.rp;
    if($(selector.wrap).hasClass('hide')) {
      return;
    }
    const rp = $(selector.wrap);
    const length = $(selector.item).length - 1;
    let arrayIndex = Array.from(Array(length + 1).keys());
    if(arrayIndex.length == 0) {
      arrayIndex = Array.from(Array(length + 1).keys());
    }
    index = this.getRandomInt(0, arrayIndex.length - 1); 
    arrayIndex.splice(index, 1);
    $(selector.item).hide();
    const activeItem = $(selector.item + '[data-index="' + index +'"]');
    activeItem.find(selector.minuteNumber).html(this.getRandomInt(minuteFrom, minuteTo));
    activeItem.show();
    const image = activeItem.find('img');
    let delay = 0;
    if(!image.hasClass('loaded')) {
      delay = 300;
      image.attr('src', image.attr('data-src'));
      image.addClass('loaded');
    }
    rp.fadeIn(this.options.rp.duration, () => {
      if(this.data.rp.openTimeInterval) {
        clearTimeout(this.data.rp.openTimeInterval);
      }
      this.data.rp.openTimeInterval = setTimeout(() => {
        this.hideRpInterval(minuteFrom, minuteTo, openTime, closeTime);
      }, openTime);
    });
  },

  hideRpInterval: function(minuteFrom, minuteTo, openTime, closeTime) {
    $(this.selectors.rp.wrap).fadeOut(this.options.rp.duration, () => {
      if(this.data.rp.closeTimeInterval) {
        clearTimeout(this.data.rp.closeTimeInterval);
      }
      this.data.rp.closeTimeInterval = setTimeout(() => {
        this.openRpInterval(minuteFrom, minuteTo, openTime, closeTime);
      }, closeTime);
    });
  },
  runSalesNotification: function() {
  	const cookieName = this.options.rp.cookieName, cookie = this.getCookie(cookieName);
  	this.loadSnippetAjax('recommended-products', () => {
      const selector = this.selectors.rp;
      if($(selector.wrap).length > 0) {
        const rp = $(selector.wrap);
        const limit = rp.data('limit'),
        minuteFrom = rp.data('minute-from'),
        minuteTo = rp.data('minute-to'),
        openTime = rp.data('interval') * 1000,
        closeTime = rp.data('closing-interval') * 1000;
        let index;
        const length = $(selector.item).length - 1;
        let list = [], i = 0, show = 0;
        for(i = 0; i < limit; i++){
          list.push(i);
        }
        list = this.shuffleArray(list);
        if(cookie != 1) {
          if(this.data.rp.closeTimeInterval) {
            clearTimeout(this.data.rp.closeTimeInterval);
          }
          setTimeout(() => {
            this.openRpInterval(minuteFrom, minuteTo, openTime, closeTime);
          }, closeTime);
        }

        // Close recommended products
        $(document).on('click', selector.closeBtn, (e) => {
          e.preventDefault();
          clearTimeout(this.data.rp.openTimeInterval);
          this.setCookie(cookieName, 1, 1);
          $(selector.wrap).slideUp(this.options.rp.duration);
        });
      }
    });
  }
});
BT.runSalesNotification();